/* app/js/src/components/graphics/edit/fields/media.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.media-options input {
  border-radius: 4px;
  background-color: #ffffff;
  border: solid 1px #e1e6eb;
  color: #232f3a;
  outline: none;
}
.media-options input ::-webkit-input-placeholder {
  color: #c9cdd6;
}
.container {
  width: 100%;
  box-sizing: border-box;
  padding: 7px 51px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  justify-content: space-between;
}
.container .media-item {
  margin-bottom: 23px;
}
.border {
  width: 100%;
  border-bottom: dashed 1px #e1e6eb;
}
.media-options {
  color: #7d8fa1;
  margin-top: 23px;
  margin-left: 11px;
  align-items: center;
  font-size: 12px;
}
.media-options .label {
  line-height: 12px;
  height: 12px;
  margin-right: 41px;
  vertical-align: super;
  display: inline-block;
}
.media-options .fit-media-dropdown {
  width: 286px;
  font-size: 14px;
  display: inline-block;
}
.media-options input {
  width: 286px;
  height: 30px;
  line-height: 30px;
  font-size: 12px;
  padding: 0 11px;
  box-sizing: border-box;
  color: #232f3a;
}
.media-options input::placeholder {
  color: #c9cdd6;
}
/*# sourceMappingURL=media.component.css.map */
